import { usePromisedRequest } from "../Common/request";
import { resolveWithBody } from "./Utils/utils";

export type CompetitorCallHistory = {
    eventId: number;
    fightId: number;
    eventRegistrationId: number;
    callCount: number;
    callingStartedAt: string; // ISO 8601 date string
};

export default {
    increaseCallCountForCompetitor(
        eventId: number,
        fightId: number,
        eventRegistrationId: number,
    ): Promise<Record<number, CompetitorCallHistory[]>> {
        return usePromisedRequest<Record<number, CompetitorCallHistory[]>>({
            url: `/api/events/${eventId}/fights/${fightId}/event-registrations/${eventRegistrationId}/actions/increase-call-count`,
            method: "post",
            json: true,
        }).then(resolveWithBody());
    },
    getCallCountHistoryMap(eventId: number): Promise<Record<number, CompetitorCallHistory[]>> {
        return usePromisedRequest<Record<number, CompetitorCallHistory[]>>({
            url: `/api/events/${eventId}/fights/call-count-history`,
            method: "get",
            json: true,
        }).then(response => response.body);
    },
};
